import React 		from 'react';
import PropTypes 	from 'prop-types';

//this.props.classes	: string of classes
//this.props.crumbs 	: array of items [{content, link}]
//this.props.clean 		: boolean

export default class BreadCrumbs extends React.PureComponent 
{
	constructor(props) 
	{
		super(props);
	}

	render() 
	{
		const {classes = '', crumbs, clean = false, type = 'slash'} = this.props;
		const items = crumbs.map((crumb, index) => {
			return (
				<li key={index} className="bread-crumbs__item">
					{crumb.link ? 
						<a href={crumb.link}>{crumb.content}</a> 
					: 
						crumb.func ? 
							<button className="btn btn--link" onClick={() => crumb.func()}>{crumb.content}</button> 
						:
							crumb.content
					}
				</li>
			);
		});

		return (
			<ul className={"bread-crumbs " + classes + ' bread-crumbs--' + type + (clean ? " bread-crumbs--clean" : "")}>
				{items}
			</ul>
		);
	}
}

BreadCrumbs.propTypes = {
		classes:	PropTypes.string
	,	crumbs:		PropTypes.arrayOf(PropTypes.shape({ content: PropTypes.string, link: PropTypes.string, func: PropTypes.func })).isRequired
	,	clean:		PropTypes.bool
	,	type:		PropTypes.oneOf(['colon', 'slash', 'arrow'])
}